export enum WithdrawalType {
  SettlementPayout = 0,
  ClientPayout = 1,
  ServicePayout = 2,
}

export const WithdrawalTypeOptions = [
  { value: WithdrawalType.SettlementPayout, label: 'Settlement Payout' },
  { value: WithdrawalType.ClientPayout, label: 'Client Payout' },
  { value: WithdrawalType.ServicePayout, label: 'Service Payout' },
];
